export const TruncateString = (string, nb) => {
    let truncate;
    let number = parseInt(nb);
    if (string.length > number) {
        truncate = string.slice(0, number) + '...';
    } else {
        truncate = string;
    }
    return truncate;
}